import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Small in-memory cache of wishlist IDs so buttons stay in sync across page
let cachedIds = null;
const subscribers = new Set();

async function loadWishlist() {
  try {
    const { data } = await api.get("/wishlist");
    cachedIds = new Set(data.map((p) => p.id));
  } catch {
    cachedIds = new Set();
  }
  subscribers.forEach((cb) => cb());
}

export default function WishlistButton({ productId, className = "" }) {
  const { user } = useAuth();
  const [, setTick] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { cachedIds = null; return; }
    if (cachedIds === null) loadWishlist();
    const cb = () => setTick((x) => x + 1);
    subscribers.add(cb);
    return () => subscribers.delete(cb);
  }, [user]);

  if (!user) return null;

  const inWishlist = cachedIds?.has(productId) || false;

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.post("/wishlist/toggle", { product_id: productId });
      if (!cachedIds) cachedIds = new Set();
      if (data.in_wishlist) cachedIds.add(productId);
      else cachedIds.delete(productId);
      subscribers.forEach((cb) => cb());
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggle}
      className={`transition ${inWishlist ? "text-arre-red" : "text-white/50 hover:text-arre-red"} ${className}`}
      aria-label={inWishlist ? "Quitar de favoritos" : "Agregar a favoritos"}
      data-testid={`wishlist-toggle-${productId}`}
    >
      <Heart className="w-5 h-5" fill={inWishlist ? "currentColor" : "none"} strokeWidth={1.5} />
    </button>
  );
}
